import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown } from "lucide-react";
import { useTheme } from "../../../hooks";
import { useBreakpoint } from "../../../core/theme/responsive";
import { getInputStyles } from "../../../styles/appointment/input";
export const COUNTRY_CODES = [
    { code: "+91", country: "India", flag: "🇮🇳" },
    { code: "+1", country: "USA/Canada", flag: "🇺🇸" },
    { code: "+44", country: "UK", flag: "🇬🇧" },
    { code: "+971", country: "UAE", flag: "🇦🇪" },
    { code: "+966", country: "Saudi Arabia", flag: "🇸🇦" },
    { code: "+65", country: "Singapore", flag: "🇸🇬" },
    { code: "+61", country: "Australia", flag: "🇦🇺" },
    { code: "+49", country: "Germany", flag: "🇩🇪" },
    { code: "+33", country: "France", flag: "🇫🇷" },
    { code: "+81", country: "Japan", flag: "🇯🇵" },
    { code: "+86", country: "China", flag: "🇨🇳" },
    { code: "+82", country: "South Korea", flag: "🇰🇷" },
    { code: "+39", country: "Italy", flag: "🇮🇹" },
    { code: "+34", country: "Spain", flag: "🇪🇸" },
    { code: "+31", country: "Netherlands", flag: "🇳🇱" },
    { code: "+46", country: "Sweden", flag: "🇸🇪" },
    { code: "+47", country: "Norway", flag: "🇳🇴" },
    { code: "+45", country: "Denmark", flag: "🇩🇰" },
    { code: "+41", country: "Switzerland", flag: "🇨🇭" },
    { code: "+43", country: "Austria", flag: "🇦🇹" },
];
export const PhoneInput = ({ countryCode, phoneNumber, onCountryCodeChange, onPhoneChange, placeholder = "Enter your phone number", disabled = false, label = "Phone Number", countryCodeLabel = "Country code", required = false, helpText, error, onBlur, }) => {
    const theme = useTheme();
    const breakpoint = useBreakpoint(theme);
    const inputStyles = getInputStyles(theme, breakpoint);
    const isMobile = breakpoint === "mobile";
    const errorBorder = error ? { borderColor: theme.colors.error } : {};
    return (_jsxs("div", { style: inputStyles.formGroup, children: [label && (_jsxs("label", { style: { ...inputStyles.label, fontSize: isMobile ? 13 : 14 }, children: [label, required && (_jsx("span", { style: { color: theme.colors.error, marginLeft: 4 }, children: "*" }))] })), _jsxs("div", { style: { display: "flex", gap: isMobile ? 6 : 8 }, children: [_jsxs("div", { style: {
                            position: "relative",
                            width: isMobile ? 88 : 100,
                            flexShrink: 0,
                        }, children: [_jsx("select", { value: countryCode, onChange: (e) => onCountryCodeChange(e.target.value), disabled: disabled, "aria-label": countryCodeLabel, style: {
                                    ...inputStyles.input,
                                    width: "100%",
                                    paddingRight: 24,
                                    cursor: disabled ? "not-allowed" : "pointer",
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    MozAppearance: "none",
                                    fontSize: isMobile ? 13 : 14,
                                    ...errorBorder,
                                }, children: COUNTRY_CODES.map((country) => (_jsxs("option", { value: country.code, children: [country.flag, " ", country.code] }, country.code))) }), _jsx(ChevronDown, { style: {
                                    position: "absolute",
                                    right: 8,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: 14,
                                    height: 14,
                                    color: theme.colors.textSecondary,
                                    pointerEvents: "none",
                                } })] }), _jsx("input", { type: "tel", value: phoneNumber, onChange: (e) => onPhoneChange(e.target.value), onBlur: onBlur, placeholder: isMobile ? "Phone number" : placeholder, disabled: disabled, "aria-invalid": error ? true : undefined, style: {
                            ...inputStyles.input,
                            flex: 1,
                            minWidth: 0,
                            fontSize: isMobile ? 13 : 14,
                            ...errorBorder,
                        } })] }), error ? (_jsx("p", { role: "alert", style: {
                    fontSize: 11,
                    color: theme.colors.error,
                    marginTop: 4,
                }, children: error })) : (helpText && (_jsx("p", { style: {
                    fontSize: 11,
                    color: theme.colors.textSecondary,
                    marginTop: 4,
                }, children: helpText })))] }));
};
